/** Internal (pre-scaling) game height in pixels. Width stretches to the screen's shape. */
export const GAME_HEIGHT = 270;

/** 16:9 is the narrowest landscape shape; wider phones see more of the world, not black bars. */
export const MIN_GAME_WIDTH = 480;

/** About 21:9 (the widest phones). Beyond this the game is letterboxed. */
export const MAX_GAME_WIDTH = 640;

export interface GameSize {
  width: number;
  height: number;
}

/**
 * Picks the internal resolution for a viewport: a fixed height, and a width matched to the
 * viewport's aspect ratio within limits. Widths are kept even to avoid half-pixel centering.
 * Portrait viewports get the 16:9 size (the page asks the player to turn the phone).
 */
export function computeGameSize(viewportWidth: number, viewportHeight: number): GameSize {
  if (viewportWidth <= 0 || viewportHeight <= 0 || viewportWidth < viewportHeight) {
    return { width: MIN_GAME_WIDTH, height: GAME_HEIGHT };
  }
  const even = Math.round((GAME_HEIGHT * viewportWidth) / viewportHeight / 2) * 2;
  return { width: Math.min(MAX_GAME_WIDTH, Math.max(MIN_GAME_WIDTH, even)), height: GAME_HEIGHT };
}
